"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLoginRequired = void 0;
var react_1 = __importDefault(require("react"));
var reconnect_js_1 = require("reconnect.js");
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var User = __importStar(require("../../Actions/User"));
function isAdmin(user) {
  var allowed = ['admin', 'management'];
  for (var _i = 0, allowed_1 = allowed; _i < allowed_1.length; _i++) {
    var grp = allowed_1[_i];
    if (user.grp.indexOf(grp) > -1) {
      return true;
    }
  }
  return false;
}
function withLoginRequired(NextComp, options) {
  var admin = options.admin,
    SiteNavBar = options.SiteNavBar,
    _a = options.renderLoginRequired,
    renderLoginRequired = _a === void 0 ? null : _a,
    _b = options.renderAccessRequired,
    renderAccessRequired = _b === void 0 ? null : _b;
  function LoginRequired(props) {
    var location = props.location;
    var showLoginModal = reconnect_js_1.useOutletSetter('login-modal');
    var hasNavBar = true;
    if ((location === null || location === void 0 ? void 0 : location.pathname.indexOf('admin')) > -1) {
      hasNavBar = false;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, hasNavBar && SiteNavBar && react_1.default.createElement(SiteNavBar, {
      location: location
    }), renderLoginRequired ? renderLoginRequired(options) : react_1.default.createElement(InnerWrapper, null, react_1.default.createElement("h1", null, "Login Required"), react_1.default.createElement(antd_1.Button, {
      onClick: function () {
        return showLoginModal({
          admin: admin
        });
      }
    }, "LOGIN")));
  }
  function AccessRequired(props) {
    return react_1.default.createElement(react_1.default.Fragment, null, renderAccessRequired ? renderAccessRequired(options) : react_1.default.createElement(InnerWrapper, null, react_1.default.createElement("h1", null, "Access Required"), react_1.default.createElement(antd_1.Button, {
      onClick: function () {
        return User.logout();
      }
    }, "Logout")));
  }
  var Wrapper = /** @class */function (_super) {
    __extends(Wrapper, _super);
    function Wrapper(props) {
      var _this = _super.call(this, props) || this;
      _this._unregister = reconnect_js_1.getOutlet('user').register(function () {
        _this.forceUpdate();
      });
      return _this;
    }
    Wrapper.prototype.componentWillUnmount = function () {
      this._unregister();
    };
    Wrapper.prototype.render = function () {
      var user = reconnect_js_1.getOutlet('user').getValue();
      var actions = reconnect_js_1.getOutlet('actions').getValue();
      if (user) {
        if (!admin) {
          return react_1.default.createElement(NextComp, __assign({
            user: user
          }, this.props));
        }
        if (admin && isAdmin(user)) {
          return actions.adminCanAccess(user, __assign({}, this.props)) ? react_1.default.createElement(NextComp, __assign({
            user: user
          }, this.props)) : react_1.default.createElement(AccessRequired, __assign({
            admin: admin
          }, this.props));
        }
      }
      return react_1.default.createElement(LoginRequired, __assign({
        admin: admin
      }, this.props));
    };
    return Wrapper;
  }(react_1.default.Component);
  Wrapper.displayName = NextComp.displayName;
  return Wrapper;
}
exports.withLoginRequired = withLoginRequired;
var InnerWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(-80px);\n"], ["\n  height: 100vh;\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transform: translateY(-80px);\n"])));
var templateObject_1;